<template>
    <!-- BEGIN: Content-->
    <div class="taxList">
      <v-container fluid>

        <v-row>
          <v-col md="12" sm="12" class="d-flex" style="justify-content:space-between">
            <v-breadcrumbs
              :items="breadcrumbs"
              divider="/"
            ></v-breadcrumbs>

            <v-btn
              color="#000000"
              class="white--text"
              depressed
              @click.stop="dialog = true"
            >
              Tax
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>

          </v-col>
        </v-row>

        <v-row>
          <v-col md="12" sm="12">
            <v-card class="card-shadow py-3">
              <v-data-table
                dense
                :headers="fields"
                :items="alltaxes"
                class="elevation-0"
                loading="false"
                :search="searchfilter"
                loading-text="Loading... Please wait"
              >
              <template v-slot:top>
                <v-text-field
                  v-model="searchfilter"
                  label="Search"
                  class="mx-4"
                ></v-text-field>
              </template>
                <template v-slot:item.name="{ item }">
                  {{ item.tax_name }}
                </template>
                <template v-slot:item.rate="{ item }">
                  {{ item.rate }}
                </template>
                <template v-slot:item.type="{ item }">
                  {{ item.type }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-icon
                    small
                    class="mr-2"
                    @click="edit(item.id)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="delete(item.id)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>


      <!-- add user dialog -->
      <v-dialog
        v-model="dialog"
        max-width="600px"
      >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Add Tax</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      label="Tax Name*"
                      v-model="item.tax_name"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      label="Rate(%)"
                      v-model="item.rate"
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-autocomplete
                      :items="taxtype"
                      label="Select tax type"
                      v-model="item.type_id"
                      item-text="type"
                      item-value="id"
                      :rules="fieldRules"
                      :search-input.sync="search"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="create"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- end user -->

      <!-- user update modal-->
      <v-dialog
        v-model="updatedialog"
        max-width="600px"
      >
        <v-card>

          <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

          <v-card-title>
            <span class="text-h6">Update Tax</span>
          </v-card-title>

          <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      label="Tax Name*"
                      v-model="item.updatetax_name"
                      required
                      :rules="fieldRules"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-text-field
                      label="Rate(%)"
                      v-model="item.updaterate"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="6"
                  >
                    <v-autocomplete
                      :items="taxtype"
                      label="Select tax type"
                      v-model="item.updatetype_id"
                      :value="item.updatetype_id"
                      item-text="type"
                      item-value="id"
                      :rules="fieldRules"
                      :search-input.sync="search"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="updatedialog = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!valid"
                @click="update"
              >
                Save
              </v-btn>
          </v-card-actions>

        </v-form>
        </v-card>
      </v-dialog>
      <!-- update user -->

    </div>

</template>
<style scope>
    @media (min-width: 576px){
        .modal-slide-in .modal-dialog {
            width: 48rem;
        }
    }
    .vs__selected, .vs__search,.vs__search:focus{
        color: #B4B7BD !important;
    }
    .vs__open-indicator,.vs__clear{
        fill:  #B4B7BD !important;
    }
</style>
<script>
import axios from 'axios'
import { Modal } from 'bootstrap'
import Pusher from 'pusher-js'
import {ability} from '../../services/ability'

export default {
    name:"taxList",
    data(){
        return {
          imageRules: [
            value => !value || value.size < 2000000 || 'Image size should be less than 2 MB!',
          ],
          fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          emailRules: [
          (v) => !!v || 'E-mail is required',
          (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
          ],
          taxes: [],
          taxtype: [],
          searchfilter: '',
          search:null,
          valid: true,
          searchrole:null,
          dialog: false,
          updatedialog: false,
          previewImage: null,
          breadcrumbs: [
            {
              text: 'Dashboard',
              disabled: false,
              href: '/',
            },
            {
              text: 'Settings',
              disabled: false,
              href: '',
            },
            {
              text: 'Taxes',
              disabled: false,
              href: '',
            },
          ],
          item:{
                tax_name:"",
                rate:"",
                type_id:"",

                updatetax_name:"",
                updaterate:"",
                updatetype_id:"",

                updateID: "",
                _method:"patch"
            },
            isBusy: false,
            loading: false,
            tableloading:true,
           disabled: false,
           fields: [
            { text: 'Tax', value: 'name' },
            { text: 'Rate(%)', value: 'rate' },
            { text: 'Type', value: 'type' },
            { text: 'Action', value: 'action' },
           ],
            updateModal: null
        }
    },
    mounted(){
      this.getTaxes()

    },
    serverPrefetch () {
      return this.getTaxes()
    },
    computed: {
     alltaxes () {

        return this.taxes
     }
    },
    beforeMount() {
      if(!ability.can('user-management', 'all')) {
        this.$router.push({ name: 'Pos' })
        return
      }
    },
    methods:{
        getTaxes(){
            axios.get('/tax').then(response=>{
                this.taxes = response.data.taxes
                this.taxtype = response.data.tax_type
            }).catch(error=>{
                console.log(error)
            })
        },
       async create(){

        if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('tax_name',this.item.tax_name)
            fd.append('rate',this.item.rate)
            fd.append('type_id',this.item.type_id)

            await axios.post('/tax', fd, config).then(response=>{
                this.$toast.success('Tax added successfully','Success',{position: 'topRight',timeout: 7000,})
                this.getTaxes()
                this.loading = false
                this.disabled = false
                this.dialog = false
                this.clear()
              })
              .catch(() => {
                this.loading = false
                this.disabled = false
                this.dialog = false
              })

          }

        },
        clear () {
          this.$refs.form.reset()
        },
        async update(){

        if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('tax_name',this.item.updatetax_name)
            fd.append('rate',this.item.updaterate)
            fd.append('type_id',this.item.updatetype_id)
            fd.append('_method',this.item._method)

            await axios.get(`/tax/${this.item.updateID}`, fd, config).then(response=>{
                this.$toast.success('Tax updated successfully','Success',{position: 'topRight',timeout: 7000,})
                this.getTaxes()
                this.loading = false
                this.disabled = false
                this.dialog = false
                this.updateModal.hide()
                this.clear()
                this.item.updateID = ''
              })
              .catch(() => {
                this.loading = false
                this.disabled = false
                this.dialog = false
              })

          }

        },
      async edit(id) {
        let index = this.alltaxes.filter(item => item.id === id );

        this.item.updatetax_name = index[0].tax_name
          this.item.updaterate = index[0].rate
          this.item.updatetype_id = index[0].type_id
          this.item.updateID = index[0].id
          this.updatedialog = true

      },
      delete(id){
            if(confirm("Are you sure to delete tax ?")){

              axios.delete(`/tax/${id}`).then(response=>{
                this.$toast.success('Tax deleted successfully','Success',{position: 'topRight',timeout: 7000,})
                this.getStores()
              })
              .catch(() => {
                console.log("Unexpected error occured")
              })
              
            }
        }
    }
}
</script>